(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glp-needs"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(scope){
    var groups = (scope || document).querySelectorAll('.glp-needs[data-reveal="true"]');
    groups.forEach(function(group){
      var cards = group.querySelectorAll('.glp-need--reveal');
      if(!('IntersectionObserver' in window)){
        cards.forEach(function(c){c.classList.add('is-visible');});
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold:0.18, rootMargin:'0px 0px -8% 0px' });
      cards.forEach(function(c){ io.observe(c); });
    });
  }
  if(document.readyState !== 'loading'){ reveal(); }
  else { document.addEventListener('DOMContentLoaded', function(){ reveal(); }); }
  document.addEventListener('shopify:section:load', function(e){ reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp-risk-assessment"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initQuiz(quiz){
    if(quiz.dataset.bound) return;
    quiz.dataset.bound = "1";
    var form   = quiz.querySelector('.glp-quiz__form');
    var result = quiz.querySelector('.glp-quiz__result');
    var btn    = quiz.querySelector('.glp-quiz__btn');
    var redo   = quiz.querySelector('.glp-result__redo');
    var errEl  = quiz.querySelector('.glp-quiz__error');
    if(!form || !btn) return;

    var tiers = Array.prototype.map.call(quiz.querySelectorAll('.glp-tier'), function(t){
      return {
        min: parseFloat(t.getAttribute('data-min')),
        max: parseFloat(t.getAttribute('data-max')),
        label: t.getAttribute('data-label') || '',
        headline: t.getAttribute('data-headline') || '',
        message: t.getAttribute('data-message') || '',
        accent: t.getAttribute('data-accent') || '#a6803f'
      };
    });

    // max possible score (robust to edited weights)
    var maxScore = 0;
    ['q1','q2','q3','q4'].forEach(function(name){
      var opts = form.querySelectorAll('input[name="'+name+'"]');
      var m = 0; opts.forEach(function(o){ m = Math.max(m, parseFloat(o.getAttribute('data-score'))||0); });
      maxScore += m;
    });
    var skinInputs = form.querySelectorAll('input[name="skincare"]');
    maxScore += skinInputs.length * 0.75;
    maxScore = Math.round(maxScore);

    function val(name){
      var el = form.querySelector('input[name="'+name+'"]:checked');
      return el;
    }

    function calculate(){
      var required = ['q1','q2','q3','q4','goal'];
      for(var i=0;i<required.length;i++){
        if(!val(required[i])){
          if(errEl){ errEl.hidden = false; }
          return;
        }
      }
      if(errEl){ errEl.hidden = true; }

      var score = 0;
      ['q1','q2','q3','q4'].forEach(function(name){
        score += parseFloat(val(name).getAttribute('data-score')) || 0;
      });
      // skincare: each item NOT used adds risk
      var gaps = [];
      skinInputs.forEach(function(inp){
        if(!inp.checked){ score += 0.75; if(inp.getAttribute('data-gap')) gaps.push(inp.getAttribute('data-gap')); }
      });
      score = Math.round(score);
      if(score > maxScore) score = maxScore;

      // pick tier
      var tier = tiers.find(function(t){ return score >= t.min && score <= t.max; }) || tiers[tiers.length-1] || null;

      // render
      result.style.setProperty('--glp-accent', tier ? tier.accent : '#a6803f');
      quiz.querySelector('.glp-result__num').textContent = score;
      quiz.querySelector('.glp-result__den').textContent = ' / ' + maxScore;
      quiz.querySelector('.glp-result__label').textContent = tier ? tier.label : '';
      quiz.querySelector('.glp-result__headline').textContent = tier ? tier.headline : '';
      quiz.querySelector('.glp-result__message').textContent = tier ? tier.message : '';

      var gapList = quiz.querySelector('.glp-result__gaps');
      gapList.innerHTML = '';
      if(gaps.length){
        var intro = document.createElement('li');
        intro.style.fontWeight = '500';
        intro.style.opacity = '0.95';
        intro.textContent = 'Gaps in your current routine:';
        gapList.appendChild(intro);
        gaps.forEach(function(g){ var li = document.createElement('li'); li.textContent = g; gapList.appendChild(li); });
      }

      var goalEl = val('goal');
      var goalNote = goalEl ? goalEl.getAttribute('data-note') : '';
      quiz.querySelector('.glp-result__goal').textContent = goalNote || '';

      result.hidden = false;
      // fill meter after paint
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          result.classList.add('is-shown');
          quiz.querySelector('.glp-result__fill').style.width = (maxScore ? (score/maxScore*100) : 0) + '%';
        });
      });
      result.scrollIntoView({behavior:'smooth', block:'center'});
    }

    btn.addEventListener('click', calculate);
    if(redo){
      redo.addEventListener('click', function(){
        form.reset();
        result.classList.remove('is-shown');
        quiz.querySelector('.glp-result__fill').style.width = '0%';
        result.hidden = true;
        form.scrollIntoView({behavior:'smooth', block:'start'});
      });
    }
  }

  function initAll(scope){
    (scope || document).querySelectorAll('.glp-quiz').forEach(initQuiz);
  }
  if(document.readyState !== 'loading'){ initAll(); }
  else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
